// // @flow

import React from 'react';
import moment from 'moment';
import printWindow from './printHelper';

type Props = {
  printData: Object,
  handoverSlips: Array
};

class PrintCollectionHandover extends React.Component<Props> {
  componentDidMount() {
    if (this.props.printData && this.props.handoverSlips) {
      printWindow('print-collection-handover');
    }
  }

  componentDidUpdate() {
    if (this.props.printData && this.props.handoverSlips) {
      printWindow('print-collection-handover');
    }
  }

  renderDenomination(slip) {
    let denomination =
      slip && slip.denomination ? Object.entries(slip.denomination) : [];
    denomination = denomination.filter(([key, value]) => !!value);
    if (!denomination.length) {
      return;
    }
    denomination = denomination.reverse();
    return denomination.map(([key, value]) => {
      return (
        <div>
          {value} * {key}
        </div>
      );
    });
  }

  renderHandoverSlips() {
    return (
      this.props &&
      this.props.handoverSlips &&
      this.props.handoverSlips.length &&
      this.props.handoverSlips.map(slip => {
        return (
          <div
            key={slip.handoverId}
            style={{
              border: '1px solid #A9A9A9',
              margin: '20px auto ',
              maxWidth: '720px',
              borderRadius: '5px'
            }}
          >
            <div
              style={{
                textAlign: 'center',
                background: '#DCDCDC',
                margin: '10px',
                borderRadius: '5px',
                WebkitPrintColorAdjust: 'exact'
              }}
            >
              <div>
                <b>Handover Slip</b>
              </div>
            </div>
            <div style={{ textAlign: 'right', margin: '10px' }}>
              <div>
                <b>Handover ID:</b> {slip.handoverId}
              </div>
            </div>
            <table style={{ maxWidth: '700px' }}>
              <tbody>
                <tr>
                  <td>
                    <b>Handover Date:</b>{' '}
                    {moment(this.props.printData.dateTime).format('DD/MM/YYYY')}
                  </td>
                  <td>
                    <b>Total CNs:</b> {slip.totalCn}
                  </td>
                </tr>

                <tr>
                  <td>
                    <b>Handover By:</b> {this.props.printData.handOverFrom}
                  </td>
                  <td>
                    <b>Business Partner Name:</b>{' '}
                    {this.props.printData.businessPartnerName || ''}
                  </td>
                </tr>

                <tr>
                  <td>
                    <b>Handover To:</b> {this.props.printData.handoverTo}
                  </td>
                  <td>
                    <b>Branch:</b> {this.props.printData.locationName}(
                    {this.props.printData.locationCode})
                  </td>
                </tr>

                {slip.paymentType === 'Cash' && (
                  <tr>
                    <td>
                      <b>Cash Handover Amount:</b> ₹{slip.handoverAmount}
                    </td>
                    <td>
                      <div style={{ display: 'flex' }}>
                        <div>
                          <b>Denomination:</b>{' '}
                        </div>
                        <div style={{ marginLeft: '10px' }}>
                          {this.renderDenomination(slip)}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}

                {slip.paymentType === 'Cheque' && (
                  <tr>
                    <td>
                      <b>Cheque Handover Amount:</b> ₹{slip.handoverAmount}
                    </td>
                    <td>
                      <b>Cheque Number:</b> {slip.chequeNumber}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      })
    );
  }

  render() {
    return (
      <div
        id="print-collection-handover"
        style={{ display: 'none', position: 'absolute' }}
      >
        <div className="print-view">{this.renderHandoverSlips()}</div>
      </div>
    );
  }
}

export default PrintCollectionHandover;
